import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { ISoftwareSettingsRepository } from "@domain/repositories";
import { SettingsTypeEnumSchema } from "@domain/schemas/BI";

@injectable()
class DeleteSoftwareSettingsService {
  @inject(TYPES.ISoftwareSettingsRepository)
  private _softwareSettingsRepository!: ISoftwareSettingsRepository;

  async executeAsync(projectId: string, fileName: string, settingsType: SettingsTypeEnumSchema, folder?: string | null, rootPath?: string | null): Promise<boolean> {
    return this._softwareSettingsRepository.deleteAsync(projectId, fileName, settingsType, folder, rootPath);
  }
}
export { DeleteSoftwareSettingsService };
